<div>
    <div class="col-12">
        <div class="py-2">
            <div class="grid grid-nogutter col-12 justify-content-end m-1 mt-3">
                <p-button (click)="onShowUploadModal()" label="{{ addLabel ?? ('hrGalleriaExtended.addLabel' | translate) }}"></p-button>
                <p-button (click)="onDelete()" *ngIf="imagesExist" label="{{ deleteLabel ?? ('hrGalleriaExtended.deleteLabel' | translate)  }}" styleClass="ml-2 p-button-outlined"></p-button>
            </div>
        </div>
        <div class="div-container">
            <ui-empty-state *ngIf="!imagesExist" [showSaveButton]="false" subTitleText=" "></ui-empty-state>
            <p-galleria
                *ngIf="imagesExist"
                [(activeIndex)]="activeIndex"
                [circular]="true"
                [numVisible]="5"
                [showIndicators]="true"
                [showItemNavigators]="true"
                [showThumbnails]="false"
                [value]="images"
                panelHeight="220"
                panelWidth="400"
            >
                <ng-template let-item pTemplate="item">
                    <img [src]="item.itemImageSrc" class="galleria-img" />
                </ng-template>
                <ng-template let-item pTemplate="footer">
                    <div class="custom-galleria-footer">
                        <span *ngIf="images" class="title-container">
                            <span class="title">{{ images[activeIndex].title }}</span>
                        </span>
                    </div>
                </ng-template>
            </p-galleria>
        </div>
    </div>
</div>

<p-dialog
    [(visible)]="uploadModal"
    [closable]="true"
    [draggable]="false"
    [modal]="true"
    [resizable]="false"
    [style]="{ width: '30vw' }"
    header="{{ 'hrGalleriaExtended.title' | translate }}"
>
    <br />
    <form [id]="'galleria_upload_form'">
        <div class="div-galleria-container">
            <div class="p-fluid formgrid grid col-12">
                <hvl-form-item class="col-12">
                    <p-fileUpload
                        #fileInput
                        (onRemove)="removeFile()"
                        (onSelect)="selectFile($event)"
                        [multiple]="false"
                        [showCancelButton]="false"
                        [showUploadButton]="false"
                        accept="image/*"
                        chooseIcon="pi pi-cloud-upload"
                        chooseLabel="{{ 'hrGalleriaExtended.chooseLabel' | translate }}"
                        draggable="true"
                        id="galleria_import"
                        maxFileSize="30000000"
                        name="image_file"
                        styleClass="hvl-file-upload"
                    >
                        <ng-template pTemplate="content">
                            <div *ngIf="!file" class="file-upload-content">
                                <label>{{ 'hrGalleriaExtended.fileDragDropLabel' | translate }}</label>
                            </div>
                        </ng-template>
                    </p-fileUpload>
                </hvl-form-item>
                <hvl-form-item class="col-12" key="fileDescription"
                               [showAsterisk]="showAsterisk"
                               label="{{ 'hrGalleriaExtended.fileDescription' | translate }}">
                    <input [(ngModel)]="fileDescription" [ngModelOptions]="{ standalone: true }" id="fileDescription" name="fileDescription" pInputText type="text" />
                </hvl-form-item>
            </div>
        </div>
        <ui-form-footer-buttons
            (onCancel)="closeUploadModal()"
            (onSave)="onSave()"
            [idPrefix]="'galleria_extended'"
            [showCancel]="true"
            [showRemove]="false"
            [showSave]="true"

        ></ui-form-footer-buttons>
    </form>
</p-dialog>
